import { cn } from 'src/lib/tailwind-merge';
import { Typography } from '../Typography';
import type { TableHeaderProps } from './type';
import { calculateColumnLeftPosition } from './util';

export const TableHeader = ({ columns, fixedColumnCount, isFixedHeader }: TableHeaderProps) => {
  const data = columns.map((column) => column.cellData);
  const widthArray = columns.map((column) => column.width);

  return (
    <thead className={cn('bg-gray-50', isFixedHeader && 'sticky top-0 z-10')}>
      <tr>
        {data.map((cell, cellIndex) => {
          const isFixedColumn = fixedColumnCount ? cellIndex < fixedColumnCount : false;
          const leftPosition = calculateColumnLeftPosition(cellIndex, widthArray);

          return (
            <th
              key={cell?.toString()}
              className={cn(
                'h-[34px] whitespace-nowrap border-b border-gray-200 bg-gray-50 p-2 text-center text-xs font-medium text-gray-500 [&:not(:last-child)]:border-r',
                (isFixedColumn || isFixedHeader) && 'sticky',
                isFixedColumn && 'z-10',
              )}
              style={
                isFixedColumn
                  ? { left: `${leftPosition}px`, width: `${widthArray[cellIndex]}px` }
                  : { width: `${widthArray[cellIndex]}px` }
              }
            >
              <Typography variant="caption3" className="text-[13px] font-normal text-gray-600">
                {cell}
              </Typography>
            </th>
          );
        })}
      </tr>
    </thead>
  );
};
